import React from "react";
import { Table } from "react-bootstrap";
import { rootUrl } from "../../../App";

const LevelTables = ({ data }) => {
    return (
        <Table responsive="sm"
            className="custom-table-3"
        >
            <thead>
                <tr>
                    <th className="text-start">Level</th>
                    <th className="text-center">Experience</th>
                    <th className="text-end">Cashback</th>
                </tr>
            </thead>
            <tbody>
                {
                    (data) &&
                    data?.map((item, index) =>
                        <tr key={item?.id || index}>
                            <td className="text-start align-middle">
                                <div className="d-flex align-items-center gap-1">
                                    <img
                                        src={rootUrl + item?.level?.photo}
                                        alt={item?.level?.name}
                                        className="img-fluid"
                                        style={{ width: "30px", height: "30px", objectFit: "contain" }}
                                    />
                                    {item?.level?.category_name}
                                </div>
                            </td>
                            <td className="text-center align-middle">
                                {(+item?.level?.category_limit).toFixed(2)}
                            </td>
                            <td className="text-end align-middle">
                                {(+item?.cashback).toFixed(2)}%
                            </td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
};

export default LevelTables;